<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card outlined>
          <v-card-title class="font-weight-bold text-center w-100">
            {{ action.study.title }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle class="font-weight-bold">Durée</v-card-subtitle>
          <v-card-text>{{ action.study.durationInDay }} jours</v-card-text>
          <v-card-subtitle class="font-weight-bold">Description générale</v-card-subtitle>
          <v-card-text>{{ action.study.descriptionGeneral }}</v-card-text>
          <v-card-subtitle class="font-weight-bold">Description de la scène</v-card-subtitle>
          <v-card-text>{{ action.study.descriptionScene }}</v-card-text>
          <v-card-subtitle class="font-weight-bold">Description de l'influence</v-card-subtitle>
          <v-card-text>{{ action.study.descriptionInfluence }}</v-card-text>
          <v-card-subtitle class="font-weight-bold">Conditions nécessaires</v-card-subtitle>
          <v-card-text>{{ action.study.conditions }}</v-card-text>
          <v-spacer></v-spacer>
          <v-btn @click="download" class="mb-3">Télécharger</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ActionDetails",
  data() {
    return {
      action: null,
    }
  },
  methods: {
    fetchCurrentPage() {
      const id = this.$route.params.id
      this.$store
        .dispatch("fetchActionDetails", { id })
        .then((response) => {
          this.action = response
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    download() {
      const win = window.open("", "", "height=700,width=900")
      win.document.write(`
        <html>
          <head>
            <title>${this.action.study.title}</title>
            <style>
              body { font-family: sans-serif; margin: 20px; }
            </style>
          </head>
          <body>
            <h1>${this.action.study.title}</h1>
            <hr/>
            <h2>Durée</h2>
            <p>${this.action.study.durationInDay}</p>
            <h2>Description général</h2>
            <p>${this.action.study.descriptionGeneral}</p>
            <h2>Description de la scène</h2>
            <p>${this.action.study.descriptionScene}</p>
            <h2>Description de l'influence</h2>
            <p>${this.action.study.descriptionInfluence}</p>
            <h2>Conditions nécessaires</h2>
            <p>${this.action.study.conditions}</p>
          </body>
        </html>
      `)
      win.document.close()
      win.focus()
      win.print()
      win.close()
    },
  },
  mounted() {
    this.fetchCurrentPage()
  },
}
</script>
